// extracted by mini-css-extract-plugin
module.exports = {"convTime":"chatgifinfo_convTime__3QFg9","addBookData":"chatgifinfo_addBookData__2V_3V"};